import React, {Component} from 'react';
import {translate} from 'react-i18next';

class BackNextButtons extends Component{
	constructor(props){
		super(props);
		this.back = this.back.bind(this);
        
        this.state = {
			number:"",			
		}
	}

	componentDidMount(){
	}

	componentDidUpdate(){
	}

	back(event){
		event.preventDefault();
		this.props.history.goBack();
	}

	next(event){
		event.preventDefault();
		switch(this.props.history.location.pathname){
			case "/transfusional_control/samples":
				if(this.props.nextStatus === ""){
					if(this.props.isValidForm()){
						this.props.search();
					}
				}
				else{
					this.props.history.push(this.props.getNextRoute());
				}
			break;
		}
	}

	render(){
		const {t} = this.props;

		return (
            <div className="container">
               <div className="col-xs-12 form-group" align="center" style={{paddingTop:"10px"}}>
					{this.props.showBack?
						<button style={{fontSize:"1em",width:"90px",margin:"10px"}} className="btn btn-info" type="button" 
						onClick={(e) => this.back(e)}>
							Atrás
						</button>
					:null}
                    {this.props.showNext? 
						<button style={{fontSize:"1em",width:"90px",margin:"10px"}} className="btn btn-info" type="button"
						onClick={(e) => this.next(e)}>
							Siguiente
						</button>
					:null}
					{this.props.showSave? 
						<button style={{fontSize:"1em",width:"90px",margin:"10px"}} className="btn btn-info" type="button"
						onClick={(e) => this.props.save(e)}>
							Guardar
						</button>
					:null}
                </div>
            </div>
		)
	}
} 

export default translate('translations') (BackNextButtons);